import { Route, Routes } from 'react-router';
import XoopsPathRedirect from '../common/XoopsPathRedirect';
import Config, { type MultiLang } from '../config';
import Database from '../database/Database';
import DatabaseXoopsPathRedirect from '../database/DatabaseXoopsPathRedirect';
import Pico from '../pico/Pico';
import PicoXoopsPathRedirect from '../pico/PicoXoopsPathRedirect';
import Categories from './Categories';
import Footer from './Footer';
import Header from './Header';
import News from './News';
import Overview from './Overview';
import Welcome from './Welcome';

interface Props {
    lang: MultiLang;
}

const Page = (props: Props) => {
    const { lang } = props;
    return (
        <div id="page">
            <Header lang={lang} />
            <div id="main">
                <div className="mainContent">
                    <Routes>
                        <Route path="/" element={<Welcome lang={lang} />} />
                        <Route path="/categories" element={<Categories lang={lang} />} />
                        <Route path="/overview" element={<Overview lang={lang} />} />
                        <Route path="/news" element={<News lang={lang} />} />
                        <Route path="/database/*" element={<Database lang={lang} />} />
                        {Config.PICO_MODULES.map((name) => (
                            <Route key={name} path={`/${name}/*`} element={<Pico lang={lang} name={name} />} />
                        ))}
                        <Route path="/modules/xoonips/*" element={<DatabaseXoopsPathRedirect lang={lang} />} />
                        {Config.PICO_MODULES.map((name) => (
                            <Route
                                key={name}
                                path={`/modules/${name}/*`}
                                element={<PicoXoopsPathRedirect lang={lang} name={name} />}
                            />
                        ))}
                        <Route path="*" element={<XoopsPathRedirect lang={lang} />} />
                    </Routes>
                </div>
            </div>
            <Footer lang={lang} />
        </div>
    );
};

export default Page;
